import React, { useState, useRef } from 'react';
import { 
  User, Phone, Camera, QrCode, 
  ShieldCheck, CheckCircle2, MessageSquare, 
  Award, GraduationCap 
} from 'lucide-react';

// ✅ IMPORTACIÓN CON RUTA ABSOLUTA
import { useAuth } from 'context/AuthContext';

const PerfilMaestro = () => {
  const { user } = useAuth(); // Identidad real del staff
  
  const [editando, setEditando] = useState(false);
  const [tieneWhatsapp, setTieneWhatsapp] = useState(true);
  const [fotoPreview, setFotoPreview] = useState(null);
  const fileInputRef = useRef(null);

  // DATOS INTEGRADOS (Sincronizados con el sistema central)
  const [maestroInfo, setMaestroInfo] = useState({
    idEmpleado: user?.uid?.slice(-6).toUpperCase() || "MSTR-7720",
    nombre: user?.displayName || "Staff Casa de Fe",
    nacimiento: "1992-05-15",
    telefono: user?.phone || "9931234567",
    rol: user?.role === 'admin' ? "Administrador de Área" : "Maestro Titular",
    aptitudes: ["Manualidades", "Canto", "Primeros Auxilios"],
    serviciosCompletados: 48
  });

  const handleFotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setFotoPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const guardarCambios = () => {
    // Aquí se conectará con updateDoc de Firebase en la v3.1
    setEditando(false);
    alert("✅ Perfil de Staff actualizado y sincronizado.");
  };

  return (
    <div className="max-w-2xl mx-auto space-y-8 animate-in fade-in duration-500 pb-20 font-sans text-left">
      
      {/* CABECERA */}
      <div className="text-center space-y-2">
        <h2 className="text-3xl font-black text-slate-900 italic tracking-tight uppercase leading-none">Mi Perfil</h2>
        <p className="text-[10px] font-black text-indigo-500 uppercase tracking-[0.2em] italic">Credencial Digital de Staff</p>
      </div>

      {!editando ? (
        <div className="space-y-6">
          {/* GAFETE DIGITAL PRO */}
          <div className="bg-white rounded-[3.5rem] shadow-2xl border-4 border-slate-100 overflow-hidden">
            <div className="bg-[#0A2440] p-10 flex flex-col items-center relative overflow-hidden">
              <div className="absolute top-0 right-0 w-40 h-40 bg-indigo-600/20 rounded-full -mr-20 -mt-20 blur-2xl" />
              
              <div className="w-36 h-36 bg-white rounded-[2.8rem] border-[6px] border-slate-800 shadow-2xl flex items-center justify-center text-slate-200 relative overflow-hidden mb-6 z-10">
                {fotoPreview ? (
                  <img src={fotoPreview} alt="Perfil" className="w-full h-full object-cover" />
                ) : (
                  <div className="bg-slate-100 w-full h-full flex items-center justify-center text-slate-300">
                    <User size={80} />
                  </div>
                )}
              </div>

              <h3 className="text-3xl font-black text-white italic tracking-tighter z-10 uppercase leading-none">{maestroInfo.nombre}</h3>
              <div className="flex items-center gap-2 mt-4 z-10 bg-indigo-600 px-5 py-2 rounded-full border border-indigo-400 shadow-lg">
                <GraduationCap size={16} className="text-white" />
                <span className="text-[10px] font-black uppercase tracking-[0.2em] text-white">
                  {maestroInfo.rol}
                </span>
              </div>
            </div>

            <div className="p-10 space-y-10">
              {/* APTITUDES */}
              <div className="space-y-4">
                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest flex items-center gap-2 italic">
                  <Award size={14} className="text-amber-500" /> Especialidades Validadas
                </p>
                <div className="flex flex-wrap gap-2 text-left">
                  {maestroInfo.aptitudes.map((h, i) => (
                    <span key={i} className="bg-slate-50 text-slate-600 px-4 py-2 rounded-2xl text-[10px] font-black uppercase tracking-tighter border border-slate-100 shadow-sm italic">
                      {h}
                    </span>
                  ))}
                </div>
              </div>

              {/* QR DE ACCESO STAFF */}
              <div className="flex flex-col items-center justify-center p-8 bg-slate-50 rounded-[3rem] border-4 border-dashed border-slate-200 group relative">
                <div className="absolute top-4 right-4 flex items-center gap-1.5">
                   <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse shadow-[0_0_8px_#10b981]" />
                   <span className="text-[8px] font-black text-emerald-600 uppercase tracking-widest">Token Activo</span>
                </div>
                <QrCode size={140} className="text-[#0A2440] mb-3 transition-transform group-hover:scale-105" strokeWidth={1} />
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em]">NÚMERO DE STAFF: {maestroInfo.idEmpleado}</span>
              </div>

              {/* STATS */}
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-indigo-50/50 p-6 rounded-3xl text-center border-2 border-indigo-100 shadow-inner">
                  <p className="text-3xl font-black text-indigo-600 tracking-tighter italic">{maestroInfo.serviciosCompletados}</p>
                  <p className="text-[9px] font-black text-indigo-400 uppercase tracking-widest mt-1">Servicios Totales</p>
                </div>
                <div className="bg-amber-50/50 p-6 rounded-3xl text-center border-2 border-amber-100 shadow-inner">
                  <p className="text-3xl font-black text-amber-600 tracking-tighter italic">4.9</p>
                  <p className="text-[9px] font-black text-amber-400 uppercase tracking-widest mt-1">Evaluación</p>
                </div>
              </div>

              <button 
                onClick={() => setEditando(true)}
                className="w-full py-6 bg-slate-900 text-white rounded-[2.5rem] font-black text-xs uppercase tracking-[0.3em] shadow-xl hover:bg-indigo-600 transition-all active:scale-95 border-b-8 border-slate-800"
              >
                Editar Perfil de Staff
              </button>
            </div>
          </div>
        </div>
      ) : (
        /* FORMULARIO DE EDICIÓN */
        <div className="bg-white p-10 rounded-[4rem] shadow-2xl border-4 border-slate-100 space-y-8 animate-in slide-in-from-right-8 text-left">
          <div className="flex flex-col items-center">
            <div 
              onClick={() => fileInputRef.current.click()}
              className="w-32 h-32 rounded-[2.5rem] bg-indigo-50 border-4 border-dashed border-indigo-200 flex flex-col items-center justify-center text-indigo-400 hover:bg-indigo-100 transition-all cursor-pointer overflow-hidden group shadow-inner"
            >
              {fotoPreview ? (
                <img src={fotoPreview} alt="Preview" className="w-full h-full object-cover" />
              ) : (
                <>
                  <Camera size={32} className="group-hover:scale-110 transition-transform" />
                  <span className="text-[8px] font-black uppercase mt-2 italic">Actualizar Foto</span>
                </>
              )}
            </div>
            <input type="file" hidden ref={fileInputRef} onChange={handleFotoChange} accept="image/*" />
          </div>

          <div className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 ml-6 uppercase tracking-widest italic">Nombre de Staff</label>
              <input 
                type="text" 
                className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-transparent focus:border-indigo-500 font-black text-xl text-slate-800 outline-none transition-all shadow-inner uppercase" 
                value={maestroInfo.nombre}
                onChange={(e) => setMaestroInfo({...maestroInfo, nombre: e.target.value})}
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2 text-left">
                <label className="text-[10px] font-black text-slate-400 ml-6 uppercase tracking-widest italic">WhatsApp</label>
                <input 
                  type="tel" 
                  className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-transparent focus:border-indigo-500 font-black text-xl text-slate-800 outline-none transition-all shadow-inner" 
                  value={maestroInfo.telefono}
                />
              </div>
              <div className="space-y-2 text-left">
                <label className="text-[10px] font-black text-slate-400 ml-6 uppercase tracking-widest italic">Nacimiento</label>
                <input 
                  type="date" 
                  className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-transparent focus:border-indigo-500 font-black text-lg text-slate-800 outline-none transition-all shadow-inner" 
                  value={maestroInfo.nacimiento}
                />
              </div>
            </div>

            <div 
              onClick={() => setTieneWhatsapp(!tieneWhatsapp)}
              className={`p-6 rounded-[2.5rem] border-4 flex items-center justify-between cursor-pointer transition-all shadow-sm ${
                tieneWhatsapp ? 'bg-emerald-50 border-emerald-200' : 'bg-slate-50 border-slate-100 opacity-60'
              }`}
            >
              <div className="flex items-center gap-4">
                <div className={`p-4 rounded-2xl ${tieneWhatsapp ? 'bg-emerald-500 text-white shadow-lg' : 'bg-slate-200 text-slate-400'}`}>
                  <MessageSquare size={20} />
                </div>
                <div className="text-left">
                  <p className="text-sm font-black uppercase tracking-tight text-slate-900 italic leading-none">Contacto WhatsApp</p>
                  <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mt-2">Habilitado para alertas de relevo</p>
                </div>
              </div>
              {tieneWhatsapp && <CheckCircle2 size={28} className="text-emerald-500" />}
            </div>
          </div>

          <div className="flex gap-4 pt-6">
            <button onClick={() => setEditando(false)} className="flex-1 py-5 font-black text-[10px] uppercase text-slate-400 tracking-widest hover:text-slate-600 transition-colors italic">Cancelar</button>
            <button 
              onClick={guardarCambios}
              className="flex-[2] py-6 bg-indigo-600 text-white rounded-3xl font-black text-[11px] uppercase tracking-[0.2em] shadow-2xl flex items-center justify-center gap-3 active:scale-95 transition-all border-b-8 border-indigo-800"
            >
              <ShieldCheck size={20} /> Guardar Perfil
            </button>
          </div>
        </div>
      )}

      {/* FOOTER PRIVACIDAD */}
      <div className="bg-white p-8 rounded-[3.5rem] border-2 border-slate-100 flex items-start gap-5 shadow-sm">
        <ShieldCheck className="text-indigo-400 shrink-0 mt-1" size={32} />
        <p className="text-[10px] text-slate-400 font-bold leading-relaxed uppercase tracking-widest italic text-left">
          Tu información de servicio y aptitudes son auditadas por el equipo de Administración. Los cambios en el ID de empleado requieren validación física de tu credencial de Casa de Fe.
        </p>
      </div>
    </div>
  );
};

export default PerfilMaestro;